import React, { useEffect, useState } from 'react';
import { Model } from 'survey-core';
import { Tabulator } from 'survey-analytics/survey.analytics.tabulator';
import 'survey-analytics/survey.analytics.tabulator.min.css';
import 'tabulator-tables/dist/css/tabulator.min.css';
import { jsPDF } from "jspdf";
import * as XLSX from 'xlsx';
import "jspdf-autotable";

window.jsPDF = jsPDF;
window.XLSX = XLSX;
const SurveyTableComponent = ({ surveyJson, surveyData }) => {
    const [surveyModel, setSurveyModel] = useState(null);
    const [tabulator, setTabulator] = useState(null);

    useEffect(() => {
        // Survey modeli yarat
        if (!surveyModel && surveyJson) {
            const newSurveyModel = new Model(surveyJson);
            setSurveyModel(newSurveyModel);
        }

        // Tabulator başlat
        if (!tabulator && surveyModel && surveyData) {
            const newTabulator = new Tabulator(
                surveyModel,
                surveyData,
                {
                    container: "surveyTableContainer", // Tabulator'un yükleneceği container
                    layout: "fitColumns", // Sütunları konteyner genişliğine sığacak şekilde ayarla
                    pagination: "local", // Sayfalama yapısını etkinleştir
                    paginationSize: 10, // Sayfa başına 10 kayıt göster
                    movableColumns: true, // Sütunları yeniden sıralama yeteneği
                    resizableRows: true, // Satırların boyutunu değiştirebilme
                }
            );
            newTabulator.render("surveyTableContainer");
            setTabulator(newTabulator);
        }
    }, [surveyModel, surveyJson, surveyData, tabulator]);

    const exportName = `AnketRaporu_${new Date().toISOString().slice(0, 10)}`;

    const handleExportXlsx = () => {
        if (!tabulator) return;
        tabulator.download("xlsx", `${exportName}.xlsx`, {sheetName: "AnketSonuclari"});
    };

    const handleExportCsv = () => {
        if (!tabulator) return;
        tabulator.download("csv", `${exportName}.csv`);
    };

    const handleExportPdf = () => {
        if (!tabulator) return;
        tabulator.download("pdf", `${exportName}.pdf`, {
            orientation: "landscape",
            title: "Anket Sonuç Raporu",
        });
    };

    return (
        <>
            <div className="d-flex flex-wrap gap-2 mb-3">
                <button className="btn btn-light-primary btn-sm" onClick={handleExportPdf} disabled={!tabulator}>
                    PDF Rapor İndir
                </button>
                <button className="btn btn-light-success btn-sm" onClick={handleExportXlsx} disabled={!tabulator}>
                    Excel İndir
                </button>
                <button className="btn btn-light-info btn-sm" onClick={handleExportCsv} disabled={!tabulator}>
                    CSV İndir
                </button>
            </div>
            <div id="surveyTableContainer" />
        </>
    );
};

export default SurveyTableComponent;
